import { Component } from '@angular/core';
import { BrandProfile, BrandingService } from '../../branding/branding.service';

@Component({
  selector: 'app-landing-page',
  templateUrl: './landing-page.component.html',
  styleUrls: ['./landing-page.component.scss'],
})
export class LandingPageComponent {
  readonly brand: BrandProfile;

  constructor(branding: BrandingService) {
    this.brand = branding.brand;
  }
}
